import { render, staticRenderFns } from "./UserManual.vue?vue&type=template&id=7ddb9042&scoped=true&"
import script from "./UserManual.vue?vue&type=script&lang=ts&"
export * from "./UserManual.vue?vue&type=script&lang=ts&"
import style0 from "./UserManual.vue?vue&type=style&index=0&id=7ddb9042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddb9042",
  null
  
)

export default component.exports